import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner, Alert, Form, Row, Col } from 'react-bootstrap';
import { getDestinatarioOrdine, risolviDestinatarioOrdine } from '../services/api';

const nomeAcquirente = (a) => a.denominazione_sociale || [a.nome, a.cognome].filter(Boolean).join(' ') || '-';

function DestinatarioOrdineModal({ ordine, onClose, onResolved }) {
  const [dati, setDati] = useState(null);
  const [nome, setNome] = useState('');
  const [cognome, setCognome] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ordine) return;
    setDati(null);
    setError(null);
    setLoading(true);
    getDestinatarioOrdine(ordine.id)
      .then((res) => {
        setDati(res.data);
        setNome(res.data.spedizione?.nome || '');
        setCognome(res.data.spedizione?.cognome || '');
      })
      .catch((err) => setError(err.response?.data?.detail || 'Errore nel caricamento dei dati del destinatario.'))
      .finally(() => setLoading(false));
  }, [ordine]);

  const conferma = async (scelta) => {
    setSaving(true);
    setError(null);
    try {
      await risolviDestinatarioOrdine(ordine.id, { scelta, nome, cognome });
      onResolved();
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore durante il salvataggio della scelta.');
    } finally {
      setSaving(false);
    }
  };

  const piuOrdini = dati && dati.n_ordini_cliente > 1;

  return (
    <Modal show={!!ordine} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Verifica destinatario - ordine #{ordine?.id}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="text-center"><Spinner animation="border" /></div>}
        {error && <Alert variant="danger">{error}</Alert>}
        {dati && (
          <>
            <p>
              Il pacco è intestato a una persona diversa dall'acquirente. Se in etichetta c'è il nome sbagliato il corriere
              non consegna e il pacco va in giacenza: scegli il nome da usare.
            </p>
            <Row className="mb-3">
              <Col md={6}>
                <h6>Acquirente (cliente in anagrafica)</h6>
                <div className="fw-bold">{nomeAcquirente(dati.acquirente)}</div>
                <small className="text-muted">{dati.indirizzo}</small>
              </Col>
              <Col md={6}>
                <h6>Destinatario indicato su Mirakl</h6>
                <Row className="g-2">
                  <Col><Form.Control size="sm" placeholder="Nome" value={nome} onChange={(e) => setNome(e.target.value)} /></Col>
                  <Col><Form.Control size="sm" placeholder="Cognome" value={cognome} onChange={(e) => setCognome(e.target.value)} /></Col>
                </Row>
                <small className="text-muted">Puoi correggerlo prima di scegliere.</small>
              </Col>
            </Row>
            {piuOrdini && (
              <Alert variant="warning" className="py-2">
                Il cliente ha {dati.n_ordini_cliente} ordini: aggiornare l'anagrafica cambierebbe il nome anche sugli altri.
                Per un destinatario occasionale scegli "Solo per questo ordine".
              </Alert>
            )}
            <div className="d-grid gap-2">
              <Button variant="outline-secondary" disabled={saving} onClick={() => conferma('acquirente')}>
                Usa il nome dell'acquirente ({nomeAcquirente(dati.acquirente)})
              </Button>
              <Button variant={piuOrdini ? 'success' : 'outline-success'} disabled={saving || !(nome || cognome)} onClick={() => conferma('solo_ordine')}>
                Solo per questo ordine: usa il nome del destinatario (l'anagrafica resta com'è)
              </Button>
              <Button variant={piuOrdini ? 'outline-danger' : 'success'} disabled={saving || !(nome || cognome)} onClick={() => conferma('spedizione')}>
                Aggiorna il cliente col nome del destinatario
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={saving}>Chiudi</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DestinatarioOrdineModal;
